import React, { createContext, useState, useEffect } from 'react';
import { auth } from '../firebaseConfig';

export const AuthContext = createContext(null);

//! Provides Information from FireBase Auth for Users. NOT FIRESTORE DOCUMENTS.
//! Data put in AuthContext is vulnerable to Dev Tools attacks.

export function AuthProvider({ children }) {
  // Initialize currentUser from localStorage if it exists.
  const [currentUser, setCurrentUser] = useState(() => {
    const storedUser = localStorage.getItem('currentUser');
    return storedUser ? JSON.parse(storedUser) : null;
  });
  
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
      localStorage.setItem('currentUser', JSON.stringify(user));
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  return (
    <AuthContext.Provider value={{ 
      currentUser, 
      loading
    }}>
      {children}
    </AuthContext.Provider>
  );
}